export default __webpack_public_path__ + "scripts/resource/09ccf3c7ebfb1c116cd9b2335e9bbcd2.svg";